import React from 'react';
import { Typography } from '@material-ui/core';
import LocaleFormatDate from './LocaleFormatDate';

type VariantType = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "body1" | "body2" | "caption" | "button" | "overline" | "srOnly" | "inherit" | undefined;

type LocaleFormatDateRangeProps = {
  dateFrom: Date;
  dateTo: Date;
  separator: string;
  variant?: VariantType
  showTime?: boolean;
};

const LocaleFormatDateRange: React.FunctionComponent<LocaleFormatDateRangeProps> = ({ dateFrom, dateTo, separator, variant, showTime = false }) => {
  return (<React.Fragment>
    <LocaleFormatDate date={dateFrom} variant={variant} showTime={showTime} />
    <Typography display="inline" variant={variant}>{` ${separator} `}</Typography>
    <LocaleFormatDate date={dateTo} variant={variant} showTime={showTime} />
  </React.Fragment>)
};

LocaleFormatDateRange.defaultProps = {
  variant: 'body1',
} as Partial<LocaleFormatDateRangeProps>;

export default LocaleFormatDateRange;
